import PermissionGuard from 'components/Global/PermissionGuard';
import MidMonthPayConfig from 'components/Settings/PayrollSettings/MidMonthPay';

export const MidMonthPaySetup = () => {
	return (
		<PermissionGuard permission="Allow_Mid-Month_Pay_Setup">
			<MidMonthPayConfig />
		</PermissionGuard>
	);
};
